import { Bot } from "lucide-react";

const TypingIndicator = () => (
  <div className="flex gap-2.5">
    <div className="w-7 h-7 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
      <Bot className="w-4 h-4 text-primary" />
    </div>
    <div className="bg-muted rounded-lg px-3.5 py-2.5 rounded-bl-sm">
      <span className="flex gap-1">
        <span className="w-2 h-2 bg-muted-foreground/40 rounded-full animate-bounce [animation-delay:0ms]" />
        <span className="w-2 h-2 bg-muted-foreground/40 rounded-full animate-bounce [animation-delay:150ms]" />
        <span className="w-2 h-2 bg-muted-foreground/40 rounded-full animate-bounce [animation-delay:300ms]" />
      </span>
    </div>
  </div>
);

export default TypingIndicator;
